"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Tooltip = (props) => {
    const { targetRef, popperProps, children } = props;
    const [hovering, setHovering] = react_1.useState(false);
    react_1.useEffect(() => {
        const ele = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
        if (!ele || !ele.addEventListener) {
            return;
        }
        const onMouseEnter = () => setHovering(true);
        const onMouseLeave = () => setHovering(false);
        ele.addEventListener('mouseenter', onMouseEnter);
        ele.addEventListener('mouseleave', onMouseLeave);
        return () => {
            ele.removeEventListener('mouseenter', onMouseEnter);
            ele.removeEventListener('mouseleave', onMouseLeave);
        };
    });
    // eslint-disable-next-line
    const Popover = require('../Popover/Popover').default; // because Tooltip comp is in withJourney and Popover uses withJourney
    return (react_1.default.createElement(Popover, Object.assign({ isOpen: hovering, targetRef: targetRef, popperProps: popperProps, mobileView: false }, props, { className: classnames_1.default(props.className, 'j-tooltip') }),
        react_1.default.createElement("div", { className: "temp-framer-fix" }, children)));
};
// cant export withJourney since withJourney uses us.
exports.default = Tooltip;
